import React, { ReactNode, useEffect } from "react";
import { Input, Form } from "antd";
import { FormListFieldData } from "antd/lib/form/FormList";
import { PlusOutlined } from "assets/icons";
import { PlateFormatType } from "store/lobby/lobby-model";
import { validationSpecialCharacters } from "utils/form/validations";
import { validationCharacters } from "utils/functions/";
import useTranslation from "utils/hooks/useTranslation";
import * as S from "./index.styled";

export interface IAddTrailersPlates {
  fields: FormListFieldData[];
  fieldsCount?: number;
  errors: ReactNode[];
  disabled: boolean;
  add: () => void;
  setFieldsCount: React.Dispatch<React.SetStateAction<number>>;
  validationPlate: RegExp;
  maxLength: number;
  plateFormatType: PlateFormatType;
}

const AddTrailersPlates = ({ fields, setFieldsCount, fieldsCount, errors, add, disabled, validationPlate, maxLength, plateFormatType }: IAddTrailersPlates): JSX.Element => {
  const INVALID_PLATE = useTranslation({ id: "invalid_plate" });
  useEffect(() => {
    setFieldsCount(fields.length);
  }, [fields]);

  return (
    <S.FormAddPlate>
      {fields.map((field) => (
        <React.Fragment key={field.key}>
          <Form.Item
            {...field}
            validateTrigger={["onChange", "onBlur"]}
            hasFeedback={!disabled}
            key={field.key}
            rules={[
              {
                pattern: validationPlate,
                message: INVALID_PLATE,
              },
            ]}
          >
            <Input
              maxLength={maxLength}
              style={S.InputCustomPlate(plateFormatType)}
              data-testid="trailersPlates"
              onKeyPress={(e) => {
                validationCharacters(e, validationSpecialCharacters);
              }}
              disabled={disabled}
            />
          </Form.Item>
        </React.Fragment>
      ))}
      <Form.Item>
        {fieldsCount < 3 && !disabled && (
          <S.AddButtonPlate
            data-testid="add-btn"
            disabled={disabled}
            onClick={() => {
              add();
              setFieldsCount(fieldsCount + 1);
            }}
            icon={<PlusOutlined className="addButtonTrailersPlates" />}
          ></S.AddButtonPlate>
        )}
        <Form.ErrorList errors={errors} />
      </Form.Item>
    </S.FormAddPlate>
  );
};

export default AddTrailersPlates;
